module.exports = __webpack_public_path__ + "static/media/logout.6d75d7e9.svg";